<template>
  <div class="followApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <div class="data">
      <img class="left" src="~assets/images/follow.jpg">
      <div class="right">
        <h2>职工生活家 <span @click="isfollow">关注</span></h2>
        <p>企业职工福利一站式服务平台! 夏盖公园年票、生日蛋糕、电影票务、拓展活动、节日慰问等产品，为企业打造全福利解决方案!</p>
      </div>
    </div>

    <div class="scenic commen" v-if="setMall.length > 0">
      <h2>
        <div class="ctitle">推荐商圈<a @click="$router.push('product?sp=1')">更多<i class="el-icon-arrow-right"></i></a></div>
      </h2>
      <ul>
        <li v-for="(item,i) in setMall" @click="toPush(item.id,'detail')">
          <div class="title">
            <img :src="baseUrl+item.logo" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <font>营业时间：{{item.business}}</font>
              <div class="price">星级<i>{{item.star}}</i> 月售:{{item.sale}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setMall:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getMall();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      isfollow:function(){
        window.location.href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI3NDIwMzk2OQ==&scene=124#wechat_redirect"
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getMall:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/index/scenicMall'
        }).then(function(response){
          var res = response.data;
          that.setMall = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .followApp{
    max-width:640px;
    background:#f5f5f5;
    margin:0 auto;
  }
  .followApp .data{
    width:92%;
    display:block;
    margin:0 auto;
    border-radius:5px;
    background:#fff;
    padding-bottom:15px
  }
  .followApp .data:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .followApp .data .left{
    float:left;
    width:20%;
    border-radius:6px;
    margin:15px 2% 0 15px
  }
  .followApp .data .right{
    float:left;
    width:70%;
    margin-top:15px;
  }
  .followApp .data .right h2{
    font-size:15px;
  }
  .followApp .data .right h2 span{
    float:right;
    font-weight:normal;
    font-size:14px;
    color:#fff;
    background:#f00;
    border-radius:5px;
    padding:1px 6px
  }
  .followApp .data .right p{
    font-size:12px;
    text-align: justify;
    color:#666;
    padding-top:5px
  }
  
  .followApp .commen{
    background:#fff;
    width:92%;
    margin:0 auto;
    border-radius:5px;
    margin-top:15px;
  }
  .followApp .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .followApp .commen h2 .ctitle{
    width:89%;
    margin:0 auto;
    position:relative;
    padding-left:3%;
  }
  .followApp .commen h2 .ctitle:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:4px;
    border-radius: 3px;
  }
  .followApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  .followApp .scenic ul li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .followApp .scenic ul li .title{
    position:relative;
    width:100%;
  }
  .followApp .scenic ul li .title img{
    float:left;
    width:30%;
    border-radius:6px;
  }
  .followApp .scenic ul li .title .conTitle{
    float:left;
    width:67%;
    margin-left:3%;
  }
  .followApp .scenic ul li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:15px;
    font-weight: bold;
  }
  .followApp .scenic li .title .conTitle font{
    display:block;
    color:#666;
    font-size:14px;
    padding:10px 0
  }
  .followApp .scenic li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .followApp .scenic li .title .conTitle .price b{
    font-size:12px;
  }

  .followApp .scenic li .title .conTitle .price{
    font-size: 14px;
    font-family: PingFang SC;
    color: #666;
  }
  .followApp .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
</style>